import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// 站点品牌后缀，统一拼接到 document.title
export const SITE_NAME = '伟创聚点 - 杭州伟创聚点数字科技有限公司'
// 全站默认关键词，含常见搜索变体（伟创/纬创/聚点/工单等）
export const DEFAULT_KEYWORDS = '伟创聚点,纬创聚点,聚点,伟创,纬创,杭州伟创聚点,伟创聚点数字科技,工单,工单管理系统,工单系统,生产工单管理,工单派工,工单跟踪,订单管理系统,订单交付管理,OMS,MES,MES制造执行系统,制造执行系统,WMS,仓储管理系统,仓储管理软件,设备云平台,设备管理系统,制造业数字化,智能制造,数字化车间,生产管理软件,工厂管理软件,制造咨询,工艺指导,流程优化,管理培训,wcjudian'

export default new Router({
  // history 模式：URL 不带 #，百度等搜索引擎可单独收录每个子页面
  // 需配合 nginx try_files $uri $uri/ /index.html 兜底（已配置）
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '伟创聚点(纬创聚点)_工单/订单/MES/WMS制造业数字化服务商',
            description: '杭州伟创聚点数字科技有限公司(伟创聚点/纬创聚点)专注制造业数字化转型,提供工单管理、订单管理系统(OMS)、MES制造执行系统、WMS仓储管理系统、设备云平台与咨询培训服务。咨询电话15116103906。',
            keywords: DEFAULT_KEYWORDS
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品 - 工单/订单/MES/WMS系统',
            description: '伟创聚点软件产品:工单管理系统、订单管理系统(OMS)、MES制造执行系统、WMS仓储管理系统、设备云平台。',
            keywords: '工单管理系统,工单系统,订单管理系统,OMS,MES,WMS,设备云平台,伟创聚点,纬创聚点'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/order'
            },
            {
              path: '/software/order',
              name: 'software_order',
              component: resolve => require(['@/view/Software_order'], resolve),
              meta: {
                title: '订单管理系统(OMS) - 伟创聚点',
                description: '伟创聚点订单管理系统(OMS)支持订单全流程在线协同与交付管理,兼顾工单派工与生产协同。',
                keywords: '订单管理系统,OMS,工单管理,工单系统,伟创聚点,纬创聚点'
              }
            },
            {
              path: '/software/mes',
              name: 'software_mes',
              component: resolve => require(['@/view/Software_mes'], resolve),
              meta: {
                title: 'MES制造执行系统 - 伟创聚点',
                description: '伟创聚点MES制造执行系统支持工单派工、生产工单跟踪、车间现场执行与数据采集。',
                keywords: 'MES,MES制造执行系统,工单派工,生产工单,伟创聚点,纬创聚点'
              }
            },
            {
              path: '/software/wms',
              name: 'software_wms',
              component: resolve => require(['@/view/Software_wms'], resolve),
              meta: {
                title: 'WMS仓储管理系统 - 伟创聚点',
                description: '伟创聚点WMS仓储管理系统助力仓储物流智能化管理。',
                keywords: 'WMS,仓储管理系统,仓储物流,伟创聚点,纬创聚点'
              }
            },
            {
              path: '/software/device',
              name: 'software_device',
              component: resolve => require(['@/view/Software_device'], resolve),
              meta: {
                title: '设备云平台 - 伟创聚点',
                description: '伟创聚点设备云平台支持设备联网与运行状态监控。',
                keywords: '设备云平台,设备联网,设备监控,伟创聚点,纬创聚点'
              }
            }
          ]
        }, {
          path: '/consulting',
          name: 'consulting',
          component: resolve => require(['@/view/Consulting'], resolve),
          meta: {
            title: '咨询培训 - 伟创聚点',
            description: '伟创聚点提供制造工艺指导、流程优化咨询、管理能力培训等咨询培训服务。',
            keywords: '制造咨询,工艺指导,流程优化,管理培训,伟创聚点,纬创聚点'
          },
          children: [
            {
              path: '/consulting',
              redirect: '/consulting/process'
            },
            {
              path: '/consulting/process',
              name: 'consulting_process',
              component: resolve => require(['@/view/Consulting_process'], resolve),
              meta: {
                title: '制造工艺指导 - 伟创聚点',
                description: '伟创聚点提供制造工艺指导服务。',
                keywords: '制造工艺指导,工艺优化,伟创聚点,纬创聚点'
              }
            },
            {
              path: '/consulting/flow',
              name: 'consulting_flow',
              component: resolve => require(['@/view/Consulting_flow'], resolve),
              meta: {
                title: '流程优化咨询 - 伟创聚点',
                description: '伟创聚点提供流程优化咨询服务。',
                keywords: '流程优化,流程咨询,伟创聚点,纬创聚点'
              }
            },
            {
              path: '/consulting/training',
              name: 'consulting_training',
              component: resolve => require(['@/view/Consulting_training'], resolve),
              meta: {
                title: '管理能力培训 - 伟创聚点',
                description: '伟创聚点提供管理能力培训服务。',
                keywords: '管理培训,能力培训,伟创聚点,纬创聚点'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务 - 伟创聚点',
            description: '伟创聚点提供软件实施、售后支持等相关服务。',
            keywords: '软件实施,售后服务,伟创聚点,纬创聚点'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态 - 伟创聚点',
            description: '伟创聚点新闻动态与行业资讯。',
            keywords: '伟创聚点新闻,纬创聚点动态,制造业数字化资讯'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍 - 杭州伟创聚点数字科技有限公司',
            description: '杭州伟创聚点数字科技有限公司(伟创聚点/纬创聚点)是一家专注制造业数字化转型的科技企业。',
            keywords: '杭州伟创聚点数字科技有限公司,伟创聚点,纬创聚点,公司介绍,关于我们'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们 - 伟创聚点',
            description: '联系伟创聚点(杭州伟创聚点数字科技有限公司),地址:浙江省杭州市,电话:15116103906。',
            keywords: '伟创聚点联系方式,纬创聚点电话,杭州伟创聚点,15116103906'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务 - 伟创聚点',
            description: '伟创聚点相关服务详情。',
            keywords: '伟创聚点服务,纬创聚点,制造业数字化'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js